import { createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import {
  Alert,
  AlertConfig,
  AlertPosition,
} from '@surface-elements/shared/alert-system/domain';
import * as AlertActions from './alert.actions';

export const ALERT_FEATURE_KEY = 'alert';

export interface AlertState extends EntityState<Alert> {
  config: AlertConfig;
  loaded: boolean;
  error: string | null;
}

export const alertAdapter: EntityAdapter<Alert> = createEntityAdapter<Alert>({
  selectId: (alert: Alert) => alert.id,
  sortComparer: (a: Alert, b: Alert) =>
    b.timestamp.getTime() - a.timestamp.getTime(),
});

export const initialAlertState: AlertState = alertAdapter.getInitialState({
  config: {
    position: AlertPosition.TOP_RIGHT,
    maxAlerts: 5,
    defaultDuration: 5000,
    enableAnimations: true,
    enableSound: false,
    stackAlerts: true,
    newestOnTop: true,
  },
  loaded: false,
  error: null,
});

export const alertReducer = createReducer(
  initialAlertState,
  on(AlertActions.addAlertSuccess, (state, { alert }) =>
    alertAdapter.addOne(alert, { ...state, loaded: true }),
  ),
  on(AlertActions.removeAlertSuccess, (state, { id }) =>
    alertAdapter.removeOne(id, state),
  ),
  on(AlertActions.clearAlertsSuccess, state =>
    alertAdapter.removeAll({ ...state, loaded: true }),
  ),
  on(AlertActions.updateConfig, (state, { config }) => ({
    ...state,
    config: { ...state.config, ...config },
  })),
  on(AlertActions.loadPersistedAlertsSuccess, (state, { alerts }) =>
    alertAdapter.setAll(alerts, { ...state, loaded: true }),
  ),
);

export const { selectAll, selectEntities, selectIds, selectTotal } =
  alertAdapter.getSelectors();
